function User (newProps) {
	const that = this;

	this.props = {};

	this.updateProperties = (toUpdateProps) => {
		that.props = toUpdateProps;
		return this;
	}

	this.getAbilities = () => {
		return that.props.abilities;
	}

	this.isAdmin = () => {
		return that.props.is_admin;
	}

	this.isFullyRegistered = () => {
		return that.props.created_at !== null;
	}

	this.isDeleted = () => {
		return that.props.deleted_at !== undefined && that.props.deleted_at !== null;
	}

	this.getFirstname = () => {
		return that.props.firstname;
	}

	this.getLastname = () => {
		return that.props.lastname;
	}

	this.getEmail = () => {
		return that.props.email;
	}

	this.updateProperties(newProps);

	return this;
}

export default User;


// WEBPACK FOOTER //
// ./src/Entities/User.js